import {
  imageStyle2dAmination,
  imageStyle3dAnimation,
  imageStyleChalkboardSketch,
  imageStyleCinematicPhoto,
  imageStyleVectorIllustration,
} from '../../../assets/images';

export const VOICE_GENDER_FEMALE = 'female';
export const VOICE_GENDER_MALE = 'male';
export type Gender = 'male' | 'female';

export const GENERATED_VIDEO_SHORT = 0;
export const GENERATED_VIDEO_AVERAGE = 1;
export const GENERATED_VIDEO_LONG = 2;

export const VOICE_TONE = [
  {
    key: 'calm',
    value: 'Calm',
  },
  {
    key: 'energetic',
    value: 'Energetic',
  },
  {
    key: 'friendly',
    value: 'Friendly',
  },
  {
    key: 'serious',
    value: 'Serious',
  },
];

export const VIDEO_LENGTH_OPTIONS = [
  {
    key: GENERATED_VIDEO_SHORT.toString(),
    value: 'Short',
  },
  {
    key: GENERATED_VIDEO_AVERAGE.toString(),
    value: 'Average',
  },
  {
    key: GENERATED_VIDEO_LONG.toString(),
    value: 'Long',
  },
];

const LANGUAGE_CONFIG_DATA = {
  ar: {
    label: 'Arabic',
    dialects: {AE: 'female'},
  },
  az: {
    label: 'Azerbaijani',
    dialects: {AZ: 'female'},
  },
  bn: {
    label: 'Bengali',
    dialects: {BD: 'female', IN: 'female'},
  },
  bs: {
    label: 'Bosnian',
    dialects: {BA: 'female'},
  },
  bg: {
    label: 'Bulgarian',
    dialects: {BG: 'female'},
  },
  ca: {
    label: 'Catalan',
    dialects: {ES: 'female'},
  },
  zh: {
    label: 'Chinese',
    dialects: {CH: 'female'},
  },
  cs: {
    label: 'Czech',
    dialects: {CZ: 'female'},
  },
  da: {
    label: 'Danish',
    dialects: {DK: 'female'},
  },
  nl: {
    label: 'Dutch',
    dialects: {NL: 'female'},
  },
  en: {
    label: 'English',
    dialects: {
      UK: 'male',
      US: 'male',
      AU: 'male',
      CA: 'female',
      HK: 'female',
      IE: 'female',
      IN: 'female',
      ZA: 'female',
    },
  },
  fr: {
    label: 'French',
    dialects: {FR: 'female'},
  },
  de: {
    label: 'German',
    dialects: {AT: 'female', CH: 'female', DE: 'female'},
  },
  el: {
    label: 'Greek',
    dialects: {GR: 'female'},
  },
  he: {
    label: 'Hebrew',
    dialects: {IL: 'female'},
  },
  hi: {
    label: 'Hindi',
    dialects: {IN: 'female'},
  },
  hu: {
    label: 'Hungarian',
    dialects: {HU: 'female'},
  },
  it: {
    label: 'Italian',
    dialects: {IT: 'female'},
  },
  kk: {
    label: 'Kazakh',
    dialects: {KZ: 'female'},
  },
  pl: {
    label: 'Polish',
    dialects: {PL: 'male'},
  },
  pt: {
    label: 'Portuguese',
    dialects: {PT: 'male', BR: 'male'},
  },
  es: {
    label: 'Spanish',
    dialects: {
      ES: 'female',
      MX: 'male',
      AR: 'female',
      BO: 'female',
      CL: 'female',
      CO: 'female',
    },
  },
  sv: {
    label: 'Swedish',
    dialects: {SE: 'male'},
  },
  tr: {
    label: 'Turkish',
    dialects: {TR: 'female'},
  },
  cy: {
    label: 'Welsh',
    dialects: {GB: 'female'},
  },
} as const;

export type LanguageKey = keyof typeof LANGUAGE_CONFIG_DATA;
export type DialectKey = string;
export const LANGUAGE_CONFIG: Record<
  LanguageKey,
  {
    label: string;
    dialects: Record<string, Gender>;
  }
> = LANGUAGE_CONFIG_DATA;
export const LANGUAGE_OPTIONS: {key: LanguageKey; value: string}[] =
  Object.entries(LANGUAGE_CONFIG)
    .map(([key, {label}]) => ({
      key: key as LanguageKey,
      value: label,
    }))
    .sort((a, b) => a.value.localeCompare(b.value));

export const VIDEO_RESPONSE_TYPES = [
  {
    key: 'conversational',
    value: 'Conversational',
  },
  {
    key: 'informative',
    value: 'Informative',
  },
  {
    key: 'professional',
    value: 'Professional',
  },
  {
    key: 'storytelling',
    value: 'Storytelling',
  },
];

export const BACKGROUND_MUSIC_OPTIONS = [
  {key: 'Empower', value: 'Empower'},
  {key: 'Happy', value: 'Happy'},
  {key: 'Inspiring', value: 'Inspiring'},
  {key: 'Upbeat', value: 'Upbeat'},
  {key: 'Uplifting', value: 'Uplifting'},
];

export const VIDEO_IMAGE_STYLES = [
  {
    key: '2D Animation',
    value: '2D Animation',
    image: imageStyle2dAmination,
  },
  {
    key: '3D Character art',
    value: '3D Character art',
    image: imageStyle3dAnimation,
  },
  {
    key: 'Chalkboard Sketch',
    value: 'Chalkboard sketch',
    image: imageStyleChalkboardSketch,
  },
  {
    key: 'Cinematic Photo',
    value: 'Cinematic photo',
    image: imageStyleCinematicPhoto,
  },
  {
    key: 'Vector Illustration',
    value: 'Vector illustration',
    image: imageStyleVectorIllustration,
  },
];
